const Landscape = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2949_51149)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.2857 16C15.2325 16 16 15.2325 16 14.2857V1.71429C16 0.767512 15.2325 0 14.2857 0H1.71429C0.767512 0 0 0.767512 0 1.71429V14.2857C0 15.2325 0.767512 16 1.71429 16H14.2857Z'
          fill='#A9AEB1'
        />
        <path
          d='M11.2891 6.63086C12.3936 6.63086 13.289 5.73543 13.289 4.63086C13.289 3.52629 12.3936 2.63086 11.2891 2.63086C10.1845 2.63086 9.28906 3.52629 9.28906 4.63086C9.28906 5.73543 10.1845 6.63086 11.2891 6.63086Z'
          fill='#565C65'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.4638 16.0006C10.0852 13.8311 9.00254 11.8769 7.40897 10.4867C5.81541 9.09648 3.81459 8.36069 1.76355 8.41058C1.17179 8.40888 0.581246 8.46818 0 8.58768V14.2863C0 15.2326 0.766765 15.9998 1.7129 16.0006H1.71429H10.4638Z'
          fill='#565C65'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.084 11.3601C10.9791 12.6584 11.5919 14.16 11.8702 15.7547C11.8845 15.8364 11.8915 15.9186 11.8915 16.0003H14.2848C15.2316 16.0003 15.9991 15.2328 15.9991 14.286V11.0737C15.2308 10.9297 14.4475 10.857 13.6608 10.8574C12.4452 10.855 11.2388 11.0252 10.084 11.3601Z'
          fill='#565C65'
        />
      </g>
      <defs>
        <clipPath id='clip0_2949_51149'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Landscape;
